import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { mq } from '../../../theme/scalingTokens';

export const useRadioGroupStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalXS,
  },
  /** Figma-aligned spacing: more breathing room between label/legend and options. */
  figmaRoot: {
    rowGap: tokens.spacingVerticalM,
  },
  radioGroup: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    [mq.mobile]: {
      gridTemplateColumns: '1fr',
    },
  },
  /** Figma-aligned single-column layout for Yes/No prompts. */
  figmaRadioGroup: {
    gridTemplateColumns: '1fr',
    rowGap: tokens.spacingVerticalS,
  },
  /** Optional Figma callout container for highlighted radio rows. */
  figmaCallout: {
    backgroundColor: tokens.colorBrandBackground2,
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
    borderRadius: '0.5rem',
    padding: tokens.spacingHorizontalM,
  },
});
